module.exports = __webpack_public_path__ + "img/9788954615358.8db19cb8.jpg";